import React from "react";
import {FormattedMessage} from "react-intl";
import RadioButtonGroupimpedance from "../../RadioButtonGroup/RadioButtonGroupimpedance/RadioButtonGroup2";
import {Link} from "react-router-dom";

let impedance = [
    {
        id: 1,
        checked: true,
        name: "impedance",
        text: <FormattedMessage id="app.pcb-quotation.pcb-impedance-no"
                                defaultMessage="No" description=""/>
    },
    {
        id: 2,
        checked: false,
        name: "impedance",
        text: <FormattedMessage id="app.pcb-quotation.pcb-impedance-yes"
                                defaultMessage="Yes" description=""/>
    },
];

let hidden = {
    display: 'none'
};
let hidden1 = {
    display: 'none'
};

const PCBImpedance = (props) => {

    let thickness = props.thickness;
    let PCBImpedance = impedance.map((item) => {
        item.checked = (item.id === props.selectedId);
        if (item.checked && item.id === 2) {
            hidden = {
                display: 'block'
            };
            hidden1 = {
                display: 'none'
            };
        } else {
            hidden = {
                display: 'none'
            };
            hidden1 = {
                display: 'none'
            };
        }
        return item;
    });

    const displayStyle = {
        display: 'block'
    };

    return (
        <div className="row" style={displayStyle}>
            <div className="col-md-12 no-padding">
                <div className="pcb-details-div">
                    <div className="col-md-3 text-right content-item-heading">
                        <FormattedMessage id="app.pcb-quotation.pcb-impedance"
                                          defaultMessage="Impedance"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        <Link id="pcbImpd-qLink" className="glyphicon glyphicon-question-sign question-link"
                              to={{
                                  pathname: '/help/impedenceHelp',
                                  thickness: {thickness}
                              }}
                        />
                    </div>
                    <div className="btn-group col-md-9 pcb-details-div-items">
                        {/*<div className="col-md-6 impedance-div">*/}
                            {/*<RadioButtonGroupimpedance data={impedance} getParams={props.setPCBParams}/>*/}
                        {/*</div>*/}

                        {/*{props.selectedIdLayer === 4 ?*/}
                            {/*<div className="col-md-3 pcb-impedance-div pull-left" style={hidden}>*/}
                                {/*<select name="pcbImpd" onChange=""*/}
                                        {/*className="form-control pcb-impedance-select">*/}

                                    {/*<option value="1">7628</option>*/}
                                    {/*<option value="2">2313</option>*/}
                                {/*</select>*/}
                            {/*</div>*/}
                            {/*:*/}
                            {/*<div className="col-md-3 pcb-impedance-div pull-left" style={hidden}>*/}
                                {/*<select name="pcbImpd" onChange=""*/}
                                        {/*className="form-control pcb-impedance-select">*/}
                                    {/*<option value="2">2313</option>*/}
                                {/*</select>*/}
                            {/*</div>*/}
                        {/*}*/}

                        <div className='impedance-div padding-impedance-left'>
                            <p className="color-black-impedance ">
                                インピーダンス制御基板は現在個別でのお見積りとなります。
                            </p>
                            <p className="  impedance-inline-block color-black-impedance" >
                                弊社で対応可能ですので、
                            </p>
                            <p  className="  impedance-inline-block " > <b>ログイン後お問い合わせフォームよりご連絡下さい。</b></p>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};
export default PCBImpedance;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/Impedance.js